document.addEventListener('DOMContentLoaded', function() {
    var oneTimeOption = document.querySelector('.wcsatt-options-prompt-label-one-time input[type="radio"]');
    var addToCartButton = document.querySelector('.single_add_to_cart_button');

    function attachSubscriptionOptionListeners() {
        var subscriptionOptions = document.querySelectorAll('.subscription-option input[type="radio"]');
        subscriptionOptions.forEach(function(option) {
            option.addEventListener('change', function() {
                if (option.checked) {
                    var wcsattOption = document.querySelector('.wcsatt-options-prompt-label-subscription input[type="radio"]');
                    if (wcsattOption) {
                        wcsattOption.checked = true;
                    }
                }
                if (addToCartButton) {
                    addToCartButton.textContent = 'S\'abonner';
                }
            });
        });
    }

    if (oneTimeOption) {
        oneTimeOption.addEventListener('change', function() {
            if (oneTimeOption.checked) {
                var subscriptionOptions = document.querySelectorAll('.subscription-option input[type="radio"]');
                subscriptionOptions.forEach(function(option) {
                    option.checked = false;
                });
            }
        });
    }

    // Attach listeners initially
    attachSubscriptionOptionListeners();

    // Observe changes in the DOM
    var observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            if (mutation.addedNodes.length > 0) {
                attachSubscriptionOptionListeners();
            }
        });
    });

    observer.observe(document.body, { childList: true, subtree: true });

    // Add event listener for elements with class select_option using event delegation
    document.body.addEventListener('click', function(event) {
        if (event.target.closest('.select_option')) {
            var subscriptionOptions = document.querySelectorAll('.subscription-option input[type="radio"]');
            subscriptionOptions.forEach(function(option) {
                option.checked = false;
            });
            if (oneTimeOption) {
                oneTimeOption.checked = true;
            }
            if (addToCartButton) {
                addToCartButton.textContent = 'Ajouter au panier';
            }
        }
    });
});